import _ from 'lodash'
class Common {
    //删除医疗管理类别空children
   static deleteEmptyChildren(data) {
        if(!_.isArray(data))return
        return data.map(val => {
          if (_.isEmpty(val.children)) {
            delete val.children
          } else if (!_.isEmpty(val.children)) {
            this.deleteEmptyChildren(val.children)
          }
          val.value = val.dictDataVal
          return val
        })
      }
      //扁平化类别children
      static  flattenChildren(data){
        if(!_.isArray(data))return
        let newData=_.cloneDeep(data)
        newData.map(val=>{
          if(val.children){
            newData.push(...val.children)
            this.flattenChildren(val.children)
            delete val.children
          }
        })
        return newData
      }
}
export { Common }